import * as React from "react";
import { forwardRef } from "react";
const SvgEnterprise = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 7v7h1v1H1v-1h1V2a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v4h2a1 1 0 0 1 1 1ZM6 5h1v2H6V5Zm0 3h1v2H6V8Zm3-3H8v2h1V5ZM8 8h1v2H8V8Zm-1 3H6v2h1v-2Zm1 0h1v2H8v-2ZM3 2h7v12H3V2Zm8 5v7h2V7h-2Z", fill: "#37474F" }));
const ForwardRef = forwardRef(SvgEnterprise);
export { ForwardRef as ReactComponent };
